(() => {
  const AUTOPLAY_DELAY = 5000;

  function initHceProductGalleryAutoplay() {
    const container = document.getElementById('SlidesCon');
    if (!container || container.dataset.hceAutoplayInitialised === 'true') return;

    const getSlides = () => Array.from(container.children).filter((item) => item.classList.contains('product-media-image'));
    const slides = getSlides();

    if (slides.length < 2) return;

    container.dataset.hceAutoplayInitialised = 'true';

    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    let timer = null;

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function modalIsOpen() {
      const modal = document.getElementById('galModal');
      return Boolean(modal && modal.classList.contains('open'));
    }

    function getCurrentSlideIndex() {
      const currentSlides = getSlides();
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      currentSlides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - container.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function setActiveThumbnail(slide) {
      const slideIndex = slide.dataset.slideIndex;
      const thumbnails = document.querySelectorAll('.gallery-slider--thumbnail');

      thumbnails.forEach((thumbnail) => {
        thumbnail.classList.toggle('active', thumbnail.dataset.slideIndex === slideIndex);
      });
    }

    function showSlide(slide) {
      if (!slide) return;

      document.querySelectorAll('.product-video-not-autoplay video').forEach((video) => video.pause());
      setActiveThumbnail(slide);
      container.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    function advanceGallery() {
      const currentSlides = getSlides();
      if (currentSlides.length < 2) return;

      const currentIndex = getCurrentSlideIndex();
      const nextIndex = (currentIndex + 1) % currentSlides.length;
      showSlide(currentSlides[nextIndex]);
    }

    function scheduleNext() {
      clearTimer();
      timer = window.setTimeout(() => {
        if (!document.hidden && !modalIsOpen()) {
          advanceGallery();
        }
        scheduleNext();
      }, AUTOPLAY_DELAY);
    }

    function restartAfterInteraction() {
      clearTimer();
      scheduleNext();
    }

    container.addEventListener('pointerdown', clearTimer, { passive: true });
    container.addEventListener('pointerup', restartAfterInteraction, { passive: true });
    container.addEventListener('pointercancel', restartAfterInteraction, { passive: true });

    document.querySelectorAll('.gallery-slider--thumbnail, .gallery-slider-arrows button').forEach((control) => {
      control.addEventListener('click', restartAfterInteraction);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearTimer();
      } else {
        scheduleNext();
      }
    });

    scheduleNext();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHceProductGalleryAutoplay, { once: true });
  } else {
    initHceProductGalleryAutoplay();
  }

  document.addEventListener('shopify:section:load', initHceProductGalleryAutoplay);
})();
